module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA/ElEQVQ4ja2UPQ6CQBBGP4xaeAcSGksrz2NjKDiLXIJTWJDQQWnotZIzWBHjmDFDXJb9wzjJS8zu+PKxOwACXEQE5AQ8hFzWvv8hGuETptyikf4qXBPQGYSd7M0WZgbZQDZXaEs3TRko1NPdhWnKAKGeriRgKZSTlJpwgWkdAcTKagXgKVTKeiy94wo4u0LZL4xn6Xhk0822yn5rvHGL0HazPQErobfeuEHomrudYJ9LTeibu4PgnktF6ErHnAVXTzYIfemYk+Dq+aQMScdsBF9fxt+2K4CtYcDVusjvvafvxsIXgMjTGFrEr179JxlXzWeYENAEnI+PhoDkDYktRb9j9fdfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_icon_warning.png
// module id = gckd
// module chunks = 1